<template>
    <transition name="slide">
      <CCard>
        <CCardBody>
          <h3>
            Integrations
          </h3>
          <br />
  
          <CAlert :color="alertType" v-if="message"> {{ message }}</CAlert>
  
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="50"
            hover
            pagination
          >
          <template #name="{ item  }">
              <td style="width: 40%">
                <strong>{{ item.name }}</strong>
              </td>
            </template>
            <template #actions="{ item }">
              <td style="width: 400px;" >
                <CButton style="margin-left:10px" color="primary" @click="edit(item.id)"
                  ><CIcon name="cil-pencil" /> Configure fields</CButton
                >
                
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </transition>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    name: "Integrations",
  
    data: () => {
      return {
        // use uuuid
        emptyGuid: "00000000-0000-0000-0000-000000000000",
        fields: ["name",  "actions"],
  
        warningModal: false,
        integration: [],
  
        // Alert
        alertType: "danger",
        message: null,
  
        // List
        items: [],
      };
    },
    computed: {},
    methods: {
      getBadge(status) {
        switch (status) {
          case true:
            return "success";
          case false:
            return "secondary";
          default:
            return "primary";
        }
      },
  
      closeModal(status, evt, accept) {
        if (accept) {
          this.delete(this.integration.id);
        }
      },
  
      edit(id) {
        this.$router.push({ path: `integrations/create/${id}` });
      },
  
      getList() {
        let self = this;
        axios
          .get(this.$apiAdress + "/v1/PartnerIntegration")
          .then(function (response) {
            self.items = [];
            response.data.map(item=>{
                self.items.push(item);
            })
          })
          .catch(function (error) {
                      self.alertType = "danger";
          setTimeout(function () {
              self.message = null;
          }, 10000);
            self.message = error;
          });
      },
    },
    mounted: function () {
      this.getList();
    },
  };
  </script>
  
  <style scoped>
  .card-body >>> table > tbody > tr > td {
    cursor: pointer;
  }
  </style>
  